<wm-form-activity-editor
  [activity]="activity"
  [form]="form"
  [workflow]="workflow"
  [includedDataEntityTypes]="includedDataEntityTypes"
  [excludedDataEntityTypes]="excludedDataEntityTypes"
  (saved)="saved.emit($event)"
></wm-form-activity-editor>